
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BRadio',
  props: {
    option: {
      type: String,
      default: 'option',
      required: true,
    },
  },
  setup(props, { emit }) {
    function radioChangeEvent() {
      emit('input', props.option)
    }

    return {
      radioChangeEvent,
    }
  },
})
